import React from 'react'
import { AiOutlineWhatsApp } from "react-icons/ai"

export default function Modelo3(props) {
    return (
        <div style={{ width: '700px', display: 'flex', justifyContent: 'space-between', margin: '5px' }}>
            <div
                style={{
                    border: '3px solid black',
                    width: '357px',
                    height: '235px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginRight:'2px'
                }}
            >
                <div
                    style={{
                        height: '80%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '15px',
                        borderBottom: '2px solid black'
                    }}
                >
                    <div
                        style={{
                            fontSize: '22pt',
                            fontWeight: 'bold',
                            height: '70%',
                            width: '100%',
                            flexWrap: 'wrap',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            padding:'5px'
                        }}
                    >
                        {props.obj.nomeAluno?.toUpperCase()}
                    </div>
                    <div
                        style={{
                            height: '30%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            marginBottom: '10px',
                            marginTop: '10px'
                        }}
                    >
                        <div>Prof: {props.obj.nomeProfessor}</div>
                        <div>Ano/Turma: {props.obj.turma}</div>
                    </div>
                </div>
                <div
                    style={{
                        height: '15%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '-15px' }}>
                        <div style={{ fontSize: '9pt' }}>(19) 3935-2769</div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AiOutlineWhatsApp style={{ fontSize: '9pt' }} />
                            <div style={{ fontSize: '9pt' }}>(19) 99955-0173</div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            font: '14px Roboto, sans-serif',
                            fontWeight: 'bolder',
                        }}
                    >
                        EMEB "PROFª MARIA BENEDICTA GUIMARÃES"
                    </div>
                </div>
            </div>
            <div
                style={{
                    border: '3px solid black',
                    width: '357px',
                    height: '235px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginLeft:'2px'
                }}
            >
                <div
                    style={{
                        height: '80%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '15px',
                        borderBottom: '2px solid black'
                    }}
                >
                    <div
                        style={{
                            fontSize: '22pt',
                            fontWeight: 'bold',
                            height: '55%',
                            width: '100%',
                            flexWrap: 'wrap',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        {props.obj.saida?.toUpperCase()}
                    </div>
                    <div
                        style={{
                            height: '40%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            marginBottom: '10px'
                        }}
                    >
                        <div>Prof: {props.obj.nomeProfessor}</div>
                        <div>Ano/Turma: {props.obj.turma}</div>
                        <div>RA: {props.obj.RA}</div>
                        <div>Validade: Março de {props.obj.anoAtual + 1}</div>
                    </div>
                </div>
                <div
                    style={{
                        height: '15%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '-15px' }}>
                        <div style={{ fontSize: '9pt' }}>(19) 3935-2769</div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AiOutlineWhatsApp style={{ fontSize: '9pt' }} />
                            <div style={{ fontSize: '9pt' }}>(19) 99955-0173</div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            font: '14px Roboto, sans-serif',
                            fontWeight: 'bolder',
                        }}
                    >
                        EMEB "PROFª MARIA BENEDICTA GUIMARÃES"
                    </div>
                </div>
            </div>
        </div>

    )
}